import amplitude from 'amplitude-js';
import { useLayoutEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';

const useSentSessionStarted = () => {
    const location = useLocation();
    const { quizId } = useParams();
    const params = new URLSearchParams(location.search);

    const isSentSessionStarted = sessionStorage.getItem('isSentSessionStarted');

    useLayoutEffect(() => {
        const utmObj = {
            funnel_name: quizId,
            is_prod_env: process.env.REACT_APP_LIVE_MODE,
            // @ts-ignore
            device_type: window.navigator?.userAgentData?.platform as any,
            operation_system_version: window.navigator.userAgent,
            'attribution.utm_source': params.get('utm_source'),
            'attribution.utm_medium': params.get('utm_medium'),
            'attribution.campaign_id': params.get('utm_campaign_id'),
            'attribution.adset_id': params.get('utm_adset_id'),
            'attribution.adset_name': params.get('utm_adset_name'),
            'attribution.campaign_name': params.get('utm_campaign_name'),
            'attribution.ad_name': params.get('utm_ad_name'),
            'attribution.ad_id': params.get('utm_ad_id'),
        };

        sessionStorage.setItem('isSentSessionStarted', 'true');

        if (!isSentSessionStarted && quizId && params) {
            setTimeout(() => {
                try {
                    amplitude.getInstance().logEvent('session_started', utmObj);
                } catch {
                    // err
                }
            }, 1000);
        }
    }, [quizId, params, isSentSessionStarted]);
};

export default useSentSessionStarted;
